import CreateIndependentProgram from '@/components/independent-study/create-independent-program/create-independent-program.vue';
import EditIndependentProgram from '@/components/independent-study/edit-independent-program/edit-independent-program';
import IndependentProgramList from '@/components/independent-study/independent-program-list/independent-program-list';
import IndependentStudyFilter from '@/components/independent-study/study-filter/independent-study-filter';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { Component, Vue } from 'vue-property-decorator';


@Component({
    name: 'independent-study',
    components: {
        'independent-study-filter': IndependentStudyFilter,
        'independent-program-list': IndependentProgramList,
        'create-independent-program': CreateIndependentProgram,
        'edit-independent-program': EditIndependentProgram,
    },
})


export default class IndependentStudy extends Vue {
    public dataLength: any;
    public limit: any = 10;
    public isLoading: boolean = true;
    public selectedOption: any = null;
    public programList = [];
    public classification: any;
    public selectedProgram: any = null;
    public isCreateProgram: boolean = false;
    public totalCount: any = 0;
    public offset: any = 0;
    public openEditProgam: boolean = false;
    public countryList: any = [];
    public menuItems: any = [];
    public filterItems: any = [
        {
            name: 'Audience',
            key: 'audience',
            isVisible: true,
            options: [{
                title: 'Student',
                value: 'student',
            },
            {
                title: 'Teacher',
                value: 'teacher',
            },
            ],
            isSelected: false,
        },
        {
            name: 'Price type',
            key: 'pricetype',
            isVisible: true,
            options: [{
                title: 'Free',
                value: false,
            },
            {
                title: 'Paid',
                value: true,
            }],
            isSelected: false,
        },
        {
            name: 'Classification',
            key: 'classification',
            isVisible: true,
            options: [],
            isSelected: false,
        },
        {
            name: 'Subject',
            key: 'subject',
            isVisible: false,
            options: [],
            isSelected: false,
        },
        {
            name: 'Framework',
            key: 'framework',
            isVisible: false,
            options: [],
            isSelected: false,
        },
        {
            name: 'Grade',
            key: 'grade',
            isVisible: false,
            options: [],
            isSelected: false,
        },
    ];
    public onClickProgramCard(item: any) {
        this.openEditProgam = true;
        this.selectedProgram = item;
    }

    public findFieldByKey(key: string) {
        return this.filterItems.find((field: any) => field.key === key);
    }
    public changeOffset(offset: any) {
        this.offset = offset;
    }

    public selectHierarchyFilters(menu: any, selectedValue: any, list: any, count: any) {
        if (selectedValue.key) {
            if (selectedValue.key === 'classification') {
                this.selectedOption = selectedValue;
                taxonomyAPI.fetchSubjects(selectedValue.id).then((subjectItem: any) => {
                    const subject = this.findFieldByKey('subject');
                    subject.options = subjectItem;
                    selectedValue.children = subjectItem;
                    subjectItem.map((item: any) => {
                        item.selected = false;
                        item.key = 'subject';
                    });
                });
            }

            if (selectedValue.key === 'subject') {
                this.selectedOption = selectedValue;
                taxonomyAPI.fetchAllFrameworksBySubCode(selectedValue.id).then((frameworkItem: any) => {
                    const frameworkKey = this.findFieldByKey('framework');
                    frameworkKey.options = frameworkItem;
                    selectedValue.children = frameworkItem;
                    frameworkItem.map((item: any) => {
                        item.selected = false;
                        item.key = 'framework';
                    });
                });
            }
            if (selectedValue.key === 'framework') {
                let subjectCode = (selectedValue.taxonomy_subject_id &&
                    selectedValue.taxonomy_subject_id.split('.')) || [];
                if (subjectCode.length > 0) {
                        subjectCode = subjectCode.length > 2 ? subjectCode.slice(1).join('.') : subjectCode.join('.');
                    }
                const framework = selectedValue.standard_framework_id;
                taxonomyAPI.fetchTaxonomyGrades(subjectCode, framework).then((gradeItem: any) => {
                        const grade = this.findFieldByKey('grade');
                        grade.options = gradeItem;
                        selectedValue.children = gradeItem;
                        gradeItem.map((item: any) => {
                            item.selected = false;
                            item.key = 'grade';
                        });
                    });
            }
        }
        this.totalCount = count;
        this.programList = list;
    }

    public selectMenu(key: any, value: any, list: any, totalCount: any) {
        if (key) {
            switch (key) {
                case 'classification':
                    this.selectedOption = value;
                    taxonomyAPI.fetchSubjects(value.id).then((subjectItem: any) => {
                        const subject = this.findFieldByKey('subject');
                        subject.options = subjectItem;
                        const option = this.filterItems[2].options.find((field: any) => field.id === value);
                        option.children = subjectItem;
                    });
                    break;
                case 'subject':
                    this.selectedOption = value;
                    taxonomyAPI.fetchAllFrameworksBySubCode(value.id).then((frameworkItem: any) => {
                        const frameworkKey = this.findFieldByKey('framework');
                        frameworkKey.options = frameworkItem;
                    });
                    break;
                case 'framework':
                    let subjectCode = (value.taxonomy_subject_id && value.taxonomy_subject_id.split('.')) || [];
                    if (subjectCode.length > 0) {
                        subjectCode = subjectCode.length > 2 ? subjectCode.slice(1).join('.') : subjectCode.join('.');
                    }
                    const framework = value.standard_framework_id;
                    taxonomyAPI.fetchTaxonomyGrades(subjectCode, framework).then((gradeItem: any) => {
                        const grade = this.findFieldByKey('grade');
                        grade.options = gradeItem;
                    });
                    break;
                default:
                    break;
            }
        }
        this.totalCount = totalCount;
        this.programList = list;
    }
    public getProgramList(dataLength: any) {
        this.dataLength = dataLength;
    }
    public loadMore() {
        this.offset = this.offset += 10;
    }
    public async created() {
        await tenantSettingsAPI.fetchClassifications().then((res) => {
            res.map((item: any) => {
                item.selected = false;
                item.key = 'classification';
            });
            const classification = this.findFieldByKey('classification');
            classification.options = res;
            this.classification = res;
            this.menuItems = res;
            this.isLoading = false;
        });
    }
    public onClickCreate(isCreateProgram: boolean) {
        this.openEditProgam = true;
        this.isCreateProgram = isCreateProgram;
    }
    public goBack() {
        this.openEditProgam = false;
        this.isCreateProgram = false;
        this.selectedProgram = null;
        this.offset = 0;
    }
}
